import { withRouter } from 'react-router-dom';
import LiteArrangementSectionScreen from './LiteArrangementSectionScreen';

export default withRouter(LiteArrangementSectionScreen);
